<template>
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-section">
                    <div class="materialContainer">
                        <div class="box">
                            <div class="login-title">
                                <h2>Login</h2>
                            </div>
                            <div class="input">
                                <label for="username" :style="[{ 'line-height': selected['username'] ? '18px' : '60px' }]">Username</label>
                                <input type="text" name="username" id="username" v-model="values.email" required v-on:blur="handleFocusOut('username')" @focus.prevent="select('username')" />
                                <span class="spin" :style="[{ width: selected['username'] ? '100%' : '0%' }]"></span>
                                <div class="valid-feedback">Please fill the name</div>
                            </div>
                            <div class="input">
                                <label for="password" :style="[{ 'line-height': selected['password'] ? '18px' : '60px' }]">Password</label>
                                <input type="password" name="password" id="password" v-model="values.password" v-on:blur="handleFocusOut('password')" @focus.prevent="select('password')" />
                                <span class="spin" :style="[{ width: selected['password'] ? '100%' : '0%' }]"></span>
                                <div class="valid-feedback">Please fill the name</div>
                            </div>
                            <div v-if="step === 'otp'" class="input">
                                <label for="otp" :style="[{ 'line-height': selected['otp'] ? '18px' : '60px' }]">Google Authenticator Code</label>
                                <input type="text" name="otp" id="otp" v-model="values.otpCode" v-on:blur="handleFocusOut('otp')" @focus.prevent="select('otp')" maxlength="6" />
                                <span class="spin" :style="[{ width: selected['otp'] ? '100%' : '0%' }]"></span>
                            </div>
                            <p v-if="step === 'otp' && setupRequired" class="mt-2 mb-1">
                                Setup code: <strong>{{ manualSecret }}</strong>
                            </p>
                            <div v-if="step === 'otp' && setupRequired && otpAuthUri" class="mt-2 mb-2 text-center">
                                <p class="mb-2">Scan this QR in Google Authenticator</p>
                                <img :src="otpQrUrl" alt="Google Authenticator QR" style="max-width: 220px; width: 100%; height: auto;" />
                            </div>
                            <a href="javascript:void(0)" @click.prevent="$router.push('/forgot_password')" class="pass-forgot">Forgot your password?</a>

                            <div class="button login">
                                <button :disabled="submitted" href="javascript:void(0)" @click.prevent="handleLogin" type="submit" class="d-flex justify-content-center align-items-center">
                                    <div v-if="submitted" class="spinner-border spinner-border-sm text-light mx-2 mb-1" role="status">
                                        <!-- <span class="sr-only">Loading...</span> -->
                                    </div>
                                    <span class="p-0 m-0">{{ step === 'credentials' ? 'Log In' : 'Verify Code' }}</span>
                                    <i class="fa fa-check"></i>
                                </button>
                            </div>

                            <p class="sign-category">
                                <span>Or sign in with</span>
                            </p>

                            <div class="row gx-md-3 gy-3">
                                <div class="col-md-6">
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <div class="social-media fb-media">
                                            <img src="@/assets/images/facebook.png" class="img-fluid" alt="" />
                                            <h6>Facebook</h6>
                                        </div>
                                    </a>
                                </div>
                                <div class="col-md-6">
                                    <a href="https://mail.google.com/" target="_blank">
                                        <div class="social-media google-media">
                                            <img src="@/assets/images/google.png" class="img-fluid" alt="" />
                                            <h6>Google</h6>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <p>
                                Not a member?
                                <router-link to="/register" class="theme-color" href="javascript:void(0)">Sign up now</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QRCode from 'qrcode'
export default {
    title: 'Voxo-Log In',
    data() {
        const isDev = process.env.NODE_ENV !== 'production'

        return {
            values: {
                email: isDev ? 'william@gmail.com' : '',
                password: isDev ? 'test' : '',
                otpCode: ''
            },
            loginUsername: isDev ? 'test@gmail.com' : '',
            loginPassword: isDev ? 'test' : '',
            selected: { username: false, password: false, otp: false },
            submitted: false,
            step: 'credentials',
            pendingToken: null,
            setupRequired: false,
            manualSecret: null,
            otpAuthUri: null,
            otpQrDataUrl: '',
        }
    },
    methods: {
        ...mapActions({
            login: 'login',
            verifyAdmin2fa: 'verifyAdmin2fa'
        }),
        async handleLogin() {            
            this.submitted = true;
            try {
                if (this.step === 'credentials') {
                    const response = await this.login({
                        email: this.values.email,
                        password: this.values.password,
                    })

                    if (response && response.status === '2FA_REQUIRED') {
                        this.step = 'otp'
                        this.pendingToken = response.pendingToken
                        this.setupRequired = response.setupRequired === true
                        this.manualSecret = response.manualSecret
                        this.otpAuthUri = response.otpAuthUri
                        await this.buildQrDataUrl()
                    } else if (response && response.status === 'Success' && this.getUser && this.getUser.roles && this.getUser.roles.includes('ROLE_ADMIN')) {
                        this.$router.push({ name: 'dashboard' })
                    }
                } else {
                    const result = await this.verifyAdmin2fa({
                        pendingToken: this.pendingToken,
                        code: this.values.otpCode,
                    })

                    if (result === 'Success' && this.getUser && this.getUser.roles && this.getUser.roles.includes('ROLE_ADMIN')) {
                        this.$router.push({ name: 'dashboard' })
                    }
                }
            } catch (error) {
                console.error('Login Failed', error)
            } finally {
                this.submitted = false;
            }
        },
        handleFocusOut(field) {
            this.values[field] === '' && (this.selected[field] = false)
        },
        select(textbox) {
            this.selected[textbox] = true
        },
        async buildQrDataUrl() {
            if (!this.otpAuthUri) {
                this.otpQrDataUrl = ''
                return
            }

            try {
                this.otpQrDataUrl = await QRCode.toDataURL(this.otpAuthUri, {
                    width: 240,
                    margin: 1,
                })
            } catch (e) {
                this.otpQrDataUrl = ''
            }
        }
    },
    created() {
        /* var user = localStorage.getItem('user') || false
        this.$store.dispatch('functionalities/setUser', { user: user })
        if (user) {
            this.$router.push('/')
        } */
    },
    computed: {
        ...mapGetters({
            getUser: 'getUser'
        }),
        otpQrUrl() {
            return this.otpQrDataUrl
        },
    },
    mounted() {
        this.values.email.length != 0 ? (this.selected.username = true) : (this.selected.username = false)
        this.values.password.length != 0 ? (this.selected.password = true) : (this.selected.password = false)
        this.values.otpCode.length != 0 ? (this.selected.otp = true) : (this.selected.otp = false)
    }
}
</script>

<style></style>
